import planningRecordsSlice from './planningRecordsSlice'
export default planningRecordsSlice.reducer
